import React from 'react';

const CSS = require('./Separator.less');

interface SeparatorProps {
  text?: string;
}

function Separator({ text }: SeparatorProps) {
  return (
    <div className={CSS.Separator}>
      <hr className={CSS.Line} />
      <span className={CSS.Text}>
        {text || 'or'}
      </span>
      <hr className={CSS.Line} />
    </div>
  );
}

export default Separator;
